// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__477nj","location":"Header_location__Q0aFY"};